import React from "react";


const USP = (props) => {
    return(
        <>

        <div className="usp-container">
        
        <img src={props.img} alt="USP" />
        <h3>{props.heading}</h3>
        <p>{props.content}</p>

        </div>



        </>
        


    );
}


export default USP ;